module.exports = __webpack_public_path__ + "static/media/write.216f53bd.png";